// API 配置：开发写死 OpenAPI；生产用同源 /api（Nginx 反代）

/** 统一订单详情接口路径（相对 API 根） */
const COMMON_INTERFACE_PATH = '/SendTransaction/CommonInterface';

function normalizeApiBase(base) {
  const b = (base || '').trim();
  if (!b) {
    return '';
  }
  return b.replace(/\/+$/, '');
}

/**
 * 订单详情完整 URL
 * - 开发：VUE_APP_API_BASE_URL=http://openapi1.pay.com
 * - 生产：VUE_APP_API_BASE_URL=/api（由 Nginx 转到 OpenAPI）
 */
function getCommonInterfaceUrl() {
  const base = normalizeApiBase(process.env.VUE_APP_API_BASE_URL || '/api');
  return `${base}${COMMON_INTERFACE_PATH}`;
}

export default {
  getCommonInterfaceUrl,
  config: {
    COMMON_INTERFACE_PATH,
    API_BASE_URL: process.env.VUE_APP_API_BASE_URL || '/api'
  }
};
